import { PowerMeterOverviewDto } from 'src/Libs/power-meters/api'
import { PowerMeterModel } from 'src/Libs/power-meters'

const fromDtoToModelTransformer = (dto: PowerMeterOverviewDto): PowerMeterModel => ({
  listIndex: dto.index,
  deviceName: dto.deviceName,
  deviceState: {
    connected: dto.deviceState.deviceConnected,
    working: dto.deviceState.deviceWorking,
    inService: dto.deviceState.deviceInService,
  },
  powerL1: dto.powerL1,
  powerL2: dto.powerL2,
  powerL3: dto.powerL3,
  balancedPhases: dto.balancedPhases ? [dto.balancedPhases[0], dto.balancedPhases[1], dto.balancedPhases[2]] : [false, false, false],
  phaseElimination: [dto.getPhaseElimination[0], dto.getPhaseElimination[1], dto.getPhaseElimination[2]],
  conditionType: dto.type,
  energy: dto.energy,
})

export default fromDtoToModelTransformer
